import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Grid } from "swiper/modules";
import "swiper/css/grid";
import "swiper/css";
import "swiper/css/navigation";
import BoatHelm from "../../Asset/icon/boat_helm.svg";
import InfoCard from "../card/InfoCard.js";
import { Link } from "react-router-dom";
import {
  getDestinationDetail,
  getProvinceDetail,
  getCountryDetail,
} from "../../redux/centerData/CenterDataSlice.js";
import { useTranslation } from "react-i18next";
import "../../Asset/scss/takemyyacht.scss";

const TopMarinaMultiRow = () => {
  const [loading, setLoading] = useState(true);
  const todos = useSelector((state) => state);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const selectedLanguage = localStorage.getItem("selectedLanguage");

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(getDestinationDetail({}));
        await dispatch(getProvinceDetail({}));
        await dispatch(getCountryDetail({}));
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [dispatch]);

  const country = todos.CenterDataSlice.Country.results?.find(
    (e) => e.country_name === "Thailand"
  );

  const renderSlides = () => {
    return todos.CenterDataSlice.Destination.results?.map((Destination) => {
      const matchingProvinces = todos.CenterDataSlice.Province.results.filter(
        (province) => province.ProvinceID === Destination.id_province
      );
      return matchingProvinces.map((province, j) => (
        <SwiperSlide key={`${Destination.id_province}-${j}`}>
          <Link
            to={`/destination/detailIsland/${Destination.name_destination_en}`}
          >
            <InfoCard
              image={Destination.destination_img}
              headline={
                selectedLanguage === "en"
                  ? Destination.name_destination_en
                  : Destination.name_destination_th
              }
              location={
                selectedLanguage === "en"
                  ? province.ProvinceEng
                  : province.ProvinceThai
              }
              country={
                selectedLanguage === "en" ? country?.country_name : "ประเทศไทย"
              }
            />
          </Link>
        </SwiperSlide>
      ));
    });
  };

  if (loading) return null;

  return (
    <div>
      <div className="mb-5">
        <img
          className="boat-helm-icon ml-08rem"
          draggable={false}
          src={BoatHelm}
          alt="BoatHelm"
        />
        <h2>{t("topDestination")}</h2>
      </div>
      <div className="top-destination relative">
        <Swiper
          modules={[Autoplay, Navigation, Grid]}
          slidesPerView={2}
          grid={{ rows: 3, fill: "row" }}
          spaceBetween={0}
          loop={true}
          autoplay={{ delay: 4000 }}
          navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
          onSwiper={(swiper) => {
            // เมื่อ swiper mount เสร็จแล้ว assign ref
            setTimeout(() => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
              swiper.navigation.destroy();
              swiper.navigation.init();
              swiper.navigation.update();
            });
          }}
          breakpoints={{
            0: { slidesPerView: 1 },
            720: { slidesPerView: 2 },
            1024: { slidesPerView: 2 },
          }}
        >
          {renderSlides()}
        </Swiper>

        {/* ปุ่ม Previous */}
        <img
          ref={prevRef}
          className="PreviousBtn absolute-left-center"
          draggable="false"
          src="/static/media/previous.1eb2e3d917050e427af4a865ebf11932.svg"
          alt="Previous"
        />

        {/* ปุ่ม Next */}
        <img
          ref={nextRef}
          className="NextBtn absolute-right-center"
          draggable="false"
          src="/static/media/next.c30fc62b5e4797c454d80d20a129c6c6.svg"
          alt="Next"
        />
      </div>
    </div>
  );
};

export default TopMarinaMultiRow;
